import { render, staticRenderFns } from "./LeakList.vue?vue&type=template&id=55849b78"
import script from "./LeakList.vue?vue&type=script&lang=js"
export * from "./LeakList.vue?vue&type=script&lang=js"
import style0 from "./LeakList.vue?vue&type=style&index=0&id=55849b78&prod&media=screen&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports